import React from 'react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  Center,
  Flex,
  Button,
} from '@chakra-ui/react'

export interface IPaymentSuccessPromptProps {
  isOpen: boolean
  onSuccess: () => void
}

const PaymentSuccessPrompt: React.FC<IPaymentSuccessPromptProps> = ({
  isOpen,
  onSuccess,
}) => (
  <Modal
    onClose={() => {}}
    isOpen={isOpen}
    scrollBehavior="outside"
    size={'lg'}
    isCentered
  >
    <ModalOverlay />
    <ModalContent
      bgColor="#272727"
      color="white"
      border="none"
      borderRadius="4px"
    >
      <ModalHeader textAlign="center">Subscription payment</ModalHeader>
      <ModalBody>
        <Center pb={8}>Payment successful!</Center>
        <Flex justifyContent="center" pb={4}>
          <Button color="white" colorScheme="brand" onClick={onSuccess}>
            Continue
          </Button>
        </Flex>
      </ModalBody>
    </ModalContent>
  </Modal>
)
export default PaymentSuccessPrompt
